import React from 'react';
import { createRoot } from 'react-dom/client';
import { Admin } from './components/Admin';
import { authService } from './services/auth';
import './admin.css';

// Проверяем авторизацию при загрузке
if (!authService.isAuthenticated() && window.location.pathname !== '/login') {
  window.location.href = '/login';
}

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(<Admin />);
} 